"use client";

import { cn } from "@/lib/utils";
import { useTopicStore } from "@/store/topic";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useCallback } from "react";
import { HomeIcon, LiveIcon, MeIcon, PortfolioIcon } from "./bottom-nav-icons";
export default function BottomNav() {
    const pathname = usePathname();
    const setSelectedNormalTopic = useTopicStore( ( state ) => state.setSelectedNormalTopic );

    const handleExploreClick = useCallback( () => {
        const { normalTopics } = useTopicStore.getState();
        if ( normalTopics.length === 0 ) return;

        const trendingTopic = normalTopics.find( ( topic ) => topic.name === "Trending" ) ?? normalTopics[0];
        let target = trendingTopic;

        while ( target.children?.length ) {
            target = target.children[0];
        }

        setSelectedNormalTopic( target );
    }, [ setSelectedNormalTopic ] );

    const navItems = [ { href: "/", label: "Home", Icon: HomeIcon }, { href: "/live", label: "Live", Icon: LiveIcon }, {
        href: "/portfolio",
        label: "Portfolio",
        Icon: PortfolioIcon,
    }, { href: "/me", label: "Me", Icon: MeIcon } ];

    return (
        <nav className="border-t border-stroke bg-surface-navigation backdrop-blur-[12px]">
            <div className="flex items-center px-2 pt-2 pb-[6px]">
                {navItems.map( ( item ) => {
                    const Icon = item.Icon;
                    const isActive = item.href === "/" ? pathname === "/" : pathname.startsWith( item.href );
                    return (
                        <Link
                            key={item.href}
                            href={item.href}
                            onClick={item.href === "/" ? handleExploreClick : undefined}
                            className={cn(
                                "relative flex min-w-0 flex-1 flex-col items-center justify-center gap-1 transition-all active:scale-95",
                                isActive ? "text-action-primary" : "text-surface-strong",
                            )}
                        >
                            <Icon className="size-6 transition-colors" isActive={isActive} />
                            <span className="text-[10px] font-semibold leading-none transition-colors">
                                {item.label}
                            </span>
                        </Link>
                    );
                } )}
            </div>
        </nav>
    );
}
